import { makeStyles } from "@material-ui/core/styles";

// D8.21.1 — Estilos de Contacts.
export const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    overflowY: "scroll",
    ...theme.scrollbarStyles,
  },
}));
